// Shared "Request Type" options for Additional Info Required (Licensing + Quotations).
export const ADDITIONAL_INFO_REQUEST_TYPE_OPTIONS = [
  { value: 'More Information Required', label: 'More Information Required' },
  { value: 'Pending Documentation', label: 'Pending Documentation' },
  { value: 'Clarification Required', label: 'Clarification Required' }
];

export const DEFAULT_ADDITIONAL_INFO_REQUEST_TYPE = ADDITIONAL_INFO_REQUEST_TYPE_OPTIONS[0].value;
